import { BuildTableOptionsArgs, BuildTableOptionsReturn } from './model';

export const buildTableOptions = ({
  preconfiguredModel,
  chosenTables,
}: BuildTableOptionsArgs): BuildTableOptionsReturn => {
  const options: string[] = preconfiguredModel.revisions.reduce(
    (finalTables: string[], tables) => {
      return [...finalTables, ...tables.tables];
    },
    [] as string[]
  );

  const cleanOptions: string[] = [...new Set(options)];

  const checkboxForm = cleanOptions.reduce(
    (finalObject: BuildTableOptionsReturn['checkboxForm'], value: string) => {
      finalObject[value] = chosenTables?.includes(value) || false;

      return finalObject;
    },
    {} as BuildTableOptionsReturn['checkboxForm']
  );

  return { options, checkboxForm };
};
